import StoreCheckoutBackend from './checkout-backend/checkout-backend';
import ClientCheckout, { PersistedCheckout } from './client-checkout';
/* eslint-disable no-underscore-dangle */
import JsonApi from './json-api/json-api';
import LineItemRequest from './line-item-request';
import { IframeSDKCheckoutUpdates } from './sdk-checkout-updates';

function ReadyMadeClientCheckout({ parentPage, sentry }) {
  const clientCheckout = new ClientCheckout(
    window.__DATA__,
    new StoreCheckoutBackend(
      new JsonApi(),
      window.__DATA__.storeId,
      parentPage
    ),
    new IframeSDKCheckoutUpdates(parentPage),
    sentry
  );
  return clientCheckout;
}

function ReadyMadePersistedCheckout(windowData) {
  return new PersistedCheckout(
    new StoreCheckoutBackend(new JsonApi(), windowData.storeId)
  );
}

export default ReadyMadeClientCheckout;
export { ReadyMadePersistedCheckout, LineItemRequest };
